import moment from 'moment'

const TextHelper = {
  install(Vue, options) {
    Vue.prototype.$textHelper = {
      capitalizeFirstLetter(text, removeUnderScore = false) {
        let txt = text
        if (removeUnderScore) {
          txt = this.underscoreToSpace(txt)
        }
        return txt.charAt(0).toUpperCase() + txt.slice(1)
      },
      underscoreToSpace(text) {
        return text.split('_').join(' ')
      },
      toTime(date) {
        return moment.unix(date).format('HH:mm:ss')
      },
      toDateTime(date) {
        return moment.unix(date).format('MMM DD, YYYY HH:mm')
      },
      toDate(date) {
        return moment.unix(date).format('MMM DD, YYYY')
      }
    }
  }
}

export default TextHelper
